var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSpecific({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3400px",
    height: "2000px",
    viewBox: "0 0 3400 2000",
    style: {
      enableBackground: "new 0 0 3400 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2C3F2;}\n\t.st1{fill:#60BF60;}\n\t.st2{fill:#339E33;}\n\t.st3{fill:#5AA85A;}\n\t.st4{fill:#333647;}\n\t.st5{fill:#BBD8FC;}\n\t.st6{fill:#99A7D8;}\n\t.st7{fill:#F1F3F2;}\n\t.st8{fill:#3E8EDD;}\n\t.st9{fill:#305777;}\n\t.st10{fill:#FF593A;}\n\t.st11{fill:#FDFFFE;}\n\t.st12{fill:#F69D85;}\n\t.st13{fill:#404660;}\n\t.st14{fill:#404D7F;}\n\t.st15{fill:#606A97;}\n\t.st16{fill:#D1836B;}\n\t.st17{fill:#AF5945;}\n\t.st18{fill:#FFFFFF;}\n\t.st19{fill:#5E3628;}\n\t.st20{fill:#30313C;}\n\t.st21{fill:#997243;}\n\t.st22{fill:#B74F2A;}\n\t.st23{fill:#FFB12A;}\n\t.st24{fill:#E58A76;}\n\t.st25{fill:#DBBFB2;}\n\t.st26{fill:#9B453A;}\n\t.st27{fill:#FACE6C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_x31_3",
    className: "st0",
    d: "M444.4,1878.7c0,0-417.5-369.9-132.5-654.2C586,951.2,481,800.3,435.4,578.2 c-65.7-319.9,107.8-564.9,486-319.9c336.3,217.9,418.3,218.7,652.2,175.9c233.9-42.8,343.6-338.4,646.6-313.1 c346.8,28.9,208.7,568.1,591.2,648.6c473.4,99.6,468.9,529,159.9,1105.6L444.4,1878.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.1,1879c0,0-188.8-279.8-126.7-327.1c62-47.3,258.8,206.2,258.8,206.2s-115.8-255.9-91.6-401.7 c24.3-145.8,211.7,195.9,256.9,363.6c0,0-11.4-236.2,96.5-332.3c107.8-96.1,68.3,386.3,68.3,386.3s67.7-277.7,141.3-291 c73.6-13.3-22.1,394-22.1,394L382.1,1879z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484,1880.4c-0.4,0-0.7-0.2-0.9-0.5L295.3,1610c-0.4-0.5-0.2-1.2,0.3-1.6c0.5-0.4,1.2-0.2,1.6,0.3 l187.8,269.9c0.4,0.5,0.2,1.2-0.3,1.6C484.4,1880.4,484.2,1880.4,484,1880.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M642.4,1879.1c-0.5,0-0.9-0.3-1.1-0.7l-180.7-496.3c-0.2-0.6,0.1-1.2,0.7-1.4c0.6-0.2,1.2,0.1,1.4,0.7 l180.7,496.3c0.2,0.6-0.1,1.2-0.7,1.4C642.6,1879.1,642.5,1879.1,642.4,1879.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.1,1878.8C731.1,1878.8,731.1,1878.8,731.1,1878.8c-0.7,0-1.2-0.6-1.1-1.2 c12.7-180.4,64.7-429.5,65.2-432c0.1-0.6,0.7-1,1.3-0.9c0.6,0.1,1,0.7,0.9,1.3c-0.5,2.5-52.5,251.4-65.2,431.7 C732.2,1878.4,731.7,1878.8,731.1,1878.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M880.1,1878.8c-0.1,0-0.2,0-0.2,0c-0.6-0.1-1-0.7-0.9-1.3c17-80.8,91.1-339.7,91.8-342.3 c0.2-0.6,0.8-0.9,1.4-0.8c0.6,0.2,0.9,0.8,0.8,1.4c-0.7,2.6-74.8,261.4-91.8,342.2C881.1,1878.4,880.6,1878.8,880.1,1878.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3018.7,1879c0,0,188.8-279.8,126.7-327.1c-62-47.3-258.8,206.2-258.8,206.2s115.8-255.9,91.6-401.7 c-24.3-145.8-211.7,195.9-256.9,363.6c0,0,11.4-236.2-96.5-332.3c-107.8-96.1-68.3,386.3-68.3,386.3s-67.7-277.7-141.3-291 c-73.6-13.3,22.1,394,22.1,394L3018.7,1879z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2916.8,1880.4c-0.2,0-0.4-0.1-0.6-0.2c-0.5-0.4-0.6-1.1-0.3-1.6l187.8-269.9c0.4-0.5,1.1-0.6,1.6-0.3 c0.5,0.4,0.6,1.1,0.3,1.6l-187.8,269.9C2917.5,1880.2,2917.2,1880.4,2916.8,1880.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2758.4,1879.1c-0.1,0-0.3,0-0.4-0.1c-0.6-0.2-0.9-0.9-0.7-1.5l180.7-496.3c0.2-0.6,0.9-0.9,1.5-0.7 c0.6,0.2,0.9,0.9,0.7,1.4l-180.7,496.3C2759.3,1878.9,2758.9,1879.1,2758.4,1879.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2669.7,1878.8c-0.6,0-1.1-0.5-1.1-1.1c-12.7-180.2-64.7-429.2-65.2-431.7c-0.1-0.6,0.3-1.2,0.9-1.3 c0.6-0.1,1.2,0.3,1.3,0.9c0.5,2.5,52.5,251.6,65.2,432C2670.8,1878.2,2670.4,1878.8,2669.7,1878.8 C2669.7,1878.8,2669.7,1878.8,2669.7,1878.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2520.7,1878.8c-0.5,0-1-0.4-1.1-0.9c-17-80.8-91-339.6-91.8-342.2c-0.2-0.6,0.2-1.2,0.8-1.4 c0.6-0.2,1.2,0.2,1.4,0.8c0.7,2.6,74.8,261.5,91.8,342.3c0.1,0.6-0.3,1.2-0.9,1.3C2520.8,1878.8,2520.8,1878.8,2520.7,1878.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M831.2,1876.8V694.5c0-40.6,32.9-73.6,73.6-73.6h1590.4c40.6,0,73.6,32.9,73.6,73.6v1182.3H831.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923,
    y: 712.7,
    className: "st5",
    width: 1553.9,
    height: 1072.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2819,1876.8H581c-25.3,0-45.9-20.6-45.9-45.9v0c0-25.3,20.6-45.9,45.9-45.9h2238c25.3,0,45.9,20.6,45.9,45.9 v0C2864.9,1856.2,2844.4,1876.8,2819,1876.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1155.3,
    y: 359.4,
    className: "st6",
    width: 973.7,
    height: 1328.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.6,
    y: 398.2,
    className: "st7",
    width: 973.7,
    height: 1328.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1681.3,1651.9c-53.9,0-97.7-43.8-97.7-97.7s43.8-97.7,97.7-97.7s97.7,43.8,97.7,97.7 S1735.2,1651.9,1681.3,1651.9z M1681.3,1465.5c-48.9,0-88.7,39.8-88.7,88.7c0,48.9,39.8,88.7,88.7,88.7 c48.9,0,88.7-39.8,88.7-88.7C1770.1,1505.3,1730.3,1465.5,1681.3,1465.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1211.4,
    y: 787.1,
    className: "st8",
    width: 785.2,
    height: 586
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,873.2h-785.2c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4h785.2c2.2,0,4,1.8,4,4 C2000.6,871.4,1998.8,873.2,1996.6,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,939.7h-785.2c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h785.2c1,0,1.7,0.8,1.7,1.7 C1998.3,939,1997.5,939.7,1996.6,939.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,1013h-785.2c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h785.2c1,0,1.7,0.8,1.7,1.7 C1998.3,1012.2,1997.5,1013,1996.6,1013z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,1306h-785.2c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h785.2c1,0,1.7,0.8,1.7,1.7 S1997.5,1306,1996.6,1306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,1232.7h-785.2c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h785.2c1,0,1.7,0.8,1.7,1.7 S1997.5,1232.7,1996.6,1232.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,1159.5h-785.2c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h785.2c1,0,1.7,0.8,1.7,1.7 S1997.5,1159.5,1996.6,1159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1996.6,1086.2h-785.2c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h785.2c1,0,1.7,0.8,1.7,1.7 S1997.5,1086.2,1996.6,1086.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1822.1,1377.1c-2.2,0-4-1.8-4-4v-586c0-2.2,1.8-4,4-4s4,1.8,4,4v586 C1826.1,1375.3,1824.3,1377.1,1822.1,1377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1327,579h-21.6c-1.6,0-2.9,1.3-2.9,2.9v106.8c0,1.6,1.3,2.9,2.9,2.9h21.6c1.6,0,2.9-1.3,2.9-2.9V581.9 C1329.9,580.3,1328.6,579,1327,579z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1432.5,579h-20c-1.6,0-2.9,1.3-2.9,2.9v61.2l-38.4-62.7c-0.5-0.9-1.4-1.4-2.4-1.4h-21 c-1.6,0-2.9,1.3-2.9,2.9v106.8c0,1.6,1.3,2.9,2.9,2.9h20c1.6,0,2.9-1.3,2.9-2.9v-59.6l37.8,61.1c0.5,0.8,1.4,1.4,2.4,1.4h21.6 c1.6,0,2.9-1.3,2.9-2.9V581.9C1435.4,580.3,1434.1,579,1432.5,579z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1543.9,579H1521c-1.2,0-2.3,0.8-2.7,2l-23.5,71l-24.3-71c-0.4-1.2-1.5-1.9-2.7-1.9h-23.4 c-0.9,0-1.8,0.5-2.3,1.2c-0.5,0.8-0.7,1.7-0.4,2.6l38.2,106.8c0.4,1.1,1.5,1.9,2.7,1.9h23c1.2,0,2.3-0.8,2.7-1.9l38.3-106.8 c0.3-0.9,0.2-1.9-0.4-2.6C1545.7,579.5,1544.8,579,1543.9,579z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1602.2,577.2c-9,0-17.2,1.5-24.1,4.4c-5.3,2.2-10.3,5.7-14.8,10.3c-4.4,4.5-8,9.8-10.5,15.5 c-3.4,7.7-5.1,17.3-5.1,28.6c0,17.7,5,31.8,14.9,42c9.9,10.2,23.3,15.4,40,15.4c16.4,0,29.8-5.2,39.7-15.5 c9.9-10.2,14.9-24.5,14.9-42.5c0-18.1-5-32.5-15-42.7C1632,582.4,1618.6,577.2,1602.2,577.2z M1628.9,634.9 c0,11.6-2.5,20.3-7.5,26c-5,5.6-11.2,8.3-19,8.3c-7.8,0-14.1-2.8-19.1-8.4c-5.1-5.7-7.6-14.3-7.6-25.6c0-11.5,2.5-20.1,7.4-25.7 c4.9-5.5,11.2-8.2,19.4-8.2c8.1,0,14.4,2.6,19.2,8.1C1626.5,614.9,1628.9,623.5,1628.9,634.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1691.9,579h-21.6c-1.6,0-2.9,1.3-2.9,2.9v106.8c0,1.6,1.3,2.9,2.9,2.9h21.6c1.6,0,2.9-1.3,2.9-2.9V581.9 C1694.7,580.3,1693.4,579,1691.9,579z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1802.5,653.3l-20.9-6.6c-0.8-0.2-1.6-0.2-2.3,0.2c-0.7,0.4-1.2,1.1-1.4,1.8c-1.7,7.2-4.3,12.5-8,15.7 c-3.6,3.2-7.8,4.7-12.9,4.7c-7,0-12.4-2.5-16.8-7.6c-4.4-5.2-6.6-14.3-6.6-27c0-12,2.3-20.6,6.7-25.7c4.4-5.1,10-7.5,17.1-7.5 c5.1,0,9.3,1.4,12.8,4.2c3.5,2.8,5.8,6.6,6.9,11.5c0.2,0.7,0.6,1.4,1.3,1.8c0.7,0.4,1.4,0.5,2.2,0.4l21.4-5.1 c0.8-0.2,1.4-0.7,1.8-1.3c0.4-0.7,0.5-1.5,0.3-2.2c-2.6-9-6.5-16.1-11.7-21c-8.7-8.2-20-12.4-33.8-12.4 c-15.7,0-28.6,5.3-38.3,15.7c-9.7,10.3-14.5,24.9-14.5,43.4c0,17.5,4.9,31.5,14.5,41.7c9.7,10.2,22.1,15.4,37.1,15.4 c12.1,0,22.2-3.1,30.1-9.1c7.9-6,13.7-15.3,17-27.5C1804.8,655.3,1804,653.8,1802.5,653.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1901.4,667.8h-56.8v-23.3h50.8c1.6,0,2.9-1.3,2.9-2.9v-18c0-1.6-1.3-2.9-2.9-2.9h-50.8v-17.9h54.8 c1.6,0,2.9-1.3,2.9-2.9v-18.1c0-1.6-1.3-2.9-2.9-2.9h-79.2c-1.6,0-2.9,1.3-2.9,2.9v106.8c0,1.6,1.3,2.9,2.9,2.9h81.2 c1.6,0,2.9-1.3,2.9-2.9v-18C1904.3,669.1,1903,667.8,1901.4,667.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1681.3,1612.5c-32.2,0-58.3-26.2-58.3-58.3c0-32.2,26.2-58.3,58.3-58.3c32.2,0,58.3,26.2,58.3,58.3 C1739.6,1586.3,1713.5,1612.5,1681.3,1612.5z M1681.3,1504.9c-27.2,0-49.3,22.1-49.3,49.3c0,27.2,22.1,49.3,49.3,49.3 c27.2,0,49.3-22.1,49.3-49.3C1730.6,1527,1708.5,1504.9,1681.3,1504.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1668.3,1567.8c-0.9,0-1.7-0.3-2.4-1c-1.4-1.3-1.4-3.5-0.1-4.9c0.2-0.2,11.8-12.6,22.8-30.5 c-2.9-6-5.4-13.1-7.3-21.5c-6.3-28.4,0.8-57.2,11.3-66.4c4.3-3.8,8.1-3.1,10-2.4c5.6,2.1,9.4,9.8,11.3,23.1 c3.5,24-6.2,48.6-17.3,67.6c7.6,13.7,17.2,19.8,23.5,22.5c9.9,4.3,20.6,4.1,28.5-0.6c4.4-2.6,7.6-7.5,9.6-13.3 c-8.7-7.1-14.4-15.7-17.3-23.7c-3.5-9.5-3.2-18.2,0.7-22.8c2.3-2.7,5.7-3.8,9.5-3c7.9,1.6,13.6,9.7,15.8,22.4 c1.3,7.6,1.1,16.4-0.8,24.4c6.5,4.4,14.6,7.9,24.4,9.5c15.8,2.5,24.5-2.7,29.3-9.1c-12.6-8-18.7-20.6-20.2-30.8 c-1.4-9.2,0.8-17.3,5.6-21.1c3.4-2.7,7.8-3.1,12.4-1.2c12.1,5,18.8,26.8,13.7,45c-0.4,1.5-1.1,3.4-1.9,5.4c0.5,0.2,1,0.4,1.5,0.6 c15.2,5.9,30.5-1.6,40.6-11.2c-8.8-8.5-10.3-18.7-10.5-24c-0.4-13.6,6.6-26.7,15.5-29.2c2.6-0.7,9-1.5,14,7 c7.3,12.4,3.8,30.1-8.9,45.4c3.8,2.3,8.6,4.3,14.6,5.7c9.1,2.1,17.4,0.6,25.1-4.6c26.9-18,36.6-73.6,36.7-74.1 c0.3-1.9,2.1-3.1,4-2.8c1.9,0.3,3.1,2.1,2.8,4c-0.4,2.4-10.2,59-39.6,78.7c-9.3,6.2-19.5,8.1-30.5,5.6c-7.5-1.7-13.3-4.2-17.8-7.3 c-11.7,11.4-29.9,20.4-48.5,13.3c-0.8-0.3-1.6-0.6-2.4-1c-5.7,8.1-16.5,15.8-36.6,12.6c-10-1.6-18.5-5-25.4-9.4 c-2.5,6.5-6.4,11.9-11.8,15.1c-9.8,5.8-22.9,6.2-34.8,1c-6.6-2.9-16.6-9.1-24.8-22.2c-10.4,16.3-20.8,27.2-21.7,28.2 C1670.2,1567.4,1669.2,1567.8,1668.3,1567.8z M1748.7,1497.6c-1,0-1.6,0.4-1.9,0.9c-1.9,2.2-2.3,8.3,0.5,15.9 c2.3,6.2,6.5,12.8,12.7,18.6c1-6.1,1-12.6,0-18.5c-1.6-9.4-5.6-15.8-10.3-16.8C1749.3,1497.6,1749,1497.6,1748.7,1497.6z  M1812.1,1490.7c-1.5,0-2.3,0.6-2.6,0.9c-2.8,2.2-4,8.1-3,14.7c1.3,8.6,6.4,19,16.9,25.8c0.6-1.4,1.1-2.8,1.4-4 c4.4-15.8-1.6-33.4-9.7-36.7C1813.8,1490.8,1812.8,1490.7,1812.1,1490.7z M1699.7,1447.5c-0.7,0-1.6,0.4-2.5,1.3 c-7.8,6.8-15,32.8-9.1,59.7c1.3,5.9,3,11.1,4.8,15.6c9.5-17.4,17.2-38.6,14.2-58.9c-2.2-15.2-6.1-17.3-6.9-17.6 C1700.1,1447.5,1699.9,1447.5,1699.7,1447.5z M1879.5,1477.9c-0.5,0-0.9,0.1-1.1,0.2c-5.2,1.5-10.8,11.4-10.5,22.4 c0.1,5.2,1.7,12.8,8.3,19.2c10.7-12.9,14.1-28,8.4-37.8C1882.5,1478.5,1880.7,1477.9,1879.5,1477.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M843.8,388.2c-3.2,0-6.3,0.3-9.4,0.8c0.3-2.3,0.5-4.7,0.5-7.1c0-31.6-25.6-57.2-57.2-57.2 c-19.9,0-37.5,10.2-47.7,25.6c-4.2-27.5-27.9-48.5-56.6-48.5c-31.6,0-57.2,25.6-57.2,57.2c0,5.8,0.9,11.3,2.5,16.6 c-0.8,0-1.6-0.1-2.5-0.1c-31.6,0-57.2,25.6-57.2,57.2c0,31.6,25.6,57.2,57.2,57.2c12.3,0,23.8-3.9,33.1-10.6 c12.7,26.6,39.8,44.9,71.2,44.9c33.6,0,62.3-21,73.6-50.6c9.8,17.3,28.4,29,49.8,29c31.6,0,57.2-25.6,57.2-57.2 S875.5,388.2,843.8,388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2802.7,474.3c3,0.1,6,0.5,8.9,1.1c-0.2-2.2-0.3-4.5-0.2-6.8c1.1-30,26.4-53.4,56.4-52.3 c18.9,0.7,35.2,11,44.4,26c5-25.9,28.2-45.1,55.4-44.1c30,1.1,53.4,26.4,52.3,56.4c-0.2,5.5-1.2,10.7-2.9,15.7c0.8,0,1.6,0,2.3,0 c30,1.1,53.4,26.4,52.3,56.4c-1.1,30-26.4,53.4-56.4,52.3c-11.7-0.4-22.4-4.6-31.1-11.2c-13,24.8-39.4,41.2-69.2,40.1 c-31.9-1.2-58.3-22.2-68.1-50.6c-10,16.1-28,26.5-48.3,25.7c-30-1.1-53.4-26.4-52.3-56.4C2747.5,496.5,2772.7,473.1,2802.7,474.3z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x37_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2613.6,807.8c2.1-0.3,4.6-1.5,6.6-2.4c11.9-5.2,18-16.7,12.7-28.6l-89-202.5c-3.9-8.9-12.8-14.5-22.5-14.1 l-158.9,5.9c-13,0.5-23.2,11.4-22.7,24.5c0.5,13,11.4,23.2,24.5,22.7l142.9-5.3l82.5,187.8 C2594.1,805.7,2603.3,809.3,2613.6,807.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2299.3,520.2c0,0,9.5,92.6,55.9,110.3c46.4,17.7,139.2-7.8,139.2-7.8l65.8,146.5c0,0,46-6.4,68.4-25.4 c-7.7-30.1-39.5-156.8-79.1-187.2c-29.7-22.7-90.6-22.4-142.5-28.9C2372.4,523.3,2299.3,520.2,2299.3,520.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2651.8,772.4l3.3,11.5c0.3,1,0.7,1.9,1.3,2.8c0,0,0,0,0,0c0.6,0.9,1.3,1.7,2.1,2.3l15.3-8.7 C2669.3,768.3,2654.9,771.5,2651.8,772.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2590.7,809.4c0.7,1.1,1.6,2,2.6,2.7c2.5,1.8,5.8,2.4,8.9,1.4l71.2-24.2c3.5-1.2,5.5-4.2,6-7.4 c0.1-1,0.1-2-0.1-2.9c-0.5-2.9-2.3-5.7-5.5-7.1l-12.9-5.6l-13.8-6c-31.2,16.2-65.8,18.1-65.8,18.1l4.5,15.8l3.5,12.1 C2589.6,807.5,2590.1,808.5,2590.7,809.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2654.8,763.7c0,0-19.6-8.6-25.1-10.3c-5.5-1.8-15.3,6.1-12.5,10.2c2.8,4.1,12.9,8.7,12.9,8.7L2654.8,763.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2673.6,789.9l-71.2,24.2c-4.5,1.5-9.6-0.3-12.3-4.3c-0.1-0.2-0.1-0.4-0.1-0.6c0.1-0.2,0.2-0.3,0.4-0.4l0,0 l88.7-30.4c0.2-0.1,0.4,0,0.5,0.1c0.2,0.1,0.3,0.3,0.3,0.4C2680.6,782.9,2679,788,2673.6,789.9 C2673.6,789.9,2673.6,789.9,2673.6,789.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2660.9,766.2c0,0,17.8,3.5,19,12.5l-27.4,9.1C2652.5,787.8,2649.8,774.7,2660.9,766.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2585.8,794.3c0,0,15.6-5.7,24,7.8l-19.8,7.6C2590.1,809.7,2587,802.9,2585.8,794.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2436.4,886.1c2,0.5,5,0.3,7.2,0.2c13-0.5,22.7-8.9,22.3-22l-8.2-221.1c-0.4-9.7-6.6-18.2-15.7-21.4 l-149.9-53c-12.3-4.3-25.8,2.1-30.1,14.4c-4.4,12.3,2.1,25.8,14.4,30.1l134.8,47.7l7.6,205 C2419.1,876.9,2426.4,883.7,2436.4,886.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2228.2,516.1c0,0-27.2,66.1,10.6,107.3c33.5,36.6,160,47.2,160,47.2l3.1,160.3c0,0,44.5,10.5,72.3,1.1 c4-30.8,23.5-164-0.4-207.8c-13.3-24.4-76.7-80.4-117.5-97.7L2228.2,516.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2414.6,879c0.3,1.3,0.8,2.4,1.4,3.5c1.7,2.6,4.5,4.4,7.8,4.6l75.1,3.8c3.7,0.2,6.7-1.8,8.2-4.6 c0.5-0.9,0.8-1.8,1-2.8c0.6-2.9-0.1-6.1-2.5-8.6l-9.9-9.9l-10.7-10.7c-35,3.6-67.8-7.4-67.8-7.4l-1.6,16.4l-1.2,12.5 C2414.3,876.9,2414.4,878,2414.6,879z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2491,860.2c0,0-15-15.2-19.5-18.8c-4.5-3.7-16.4,0.1-15.4,4.9c1.1,4.8,8.8,12.8,8.8,12.8L2491,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2414,878.9c0,0.2,0,0.2,0,0.2c1,4.8,5,8.3,9.8,8.6l31.3,1.6l43.8,2.2l0,0c1.8,0.1,3.4-0.3,4.8-1 c2.8-1.4,4.6-4.2,5.1-6.9c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.2l-0.1,0l-1.9-0.1l-26.3-1.2l-20.8-1l-5.3-0.3l-19.3-0.9 l0,0l-11.1-0.5l-9-0.4c0,0-0.1,0-0.1,0c-0.1,0-0.3,0.1-0.4,0.2C2414,878.7,2414,878.8,2414,878.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2495.7,864.9c0,0,15.2,9.8,13.1,18.6l-28.9-1.6C2480,881.9,2482.3,868.7,2495.7,864.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2415.6,863.3c0,0,16.4,1.8,19,16.1l-20.7-0.2C2414,879.2,2413.9,873.4,2415.6,863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2383.2,307c0,0-26.2,137.1-8,176c15.3,32.8,149.3,59.4,149.3,59.4s-4.3-17.9,4.8-43.6 c0,0-33.5-27.1-73.3-48.9C2456,449.9,2447.3,321.9,2383.2,307z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2324.9,
    y: 266.5,
    transform: "matrix(0.1099 -0.9939 0.9939 0.1099 1812.2782 2595.0876)",
    className: "st12",
    width: 60.3,
    height: 38.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2343.1,284.4c15.2,9.9,30.4,9.9,30.4,9.9l1.3-11.6L2343.1,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2327.4,525.3l2.3,0.3c35.3,3.9,67.1-21.6,71-56.9l0.2-56.2c3.9-35.3-10.9-108.9-46.3-112.8l-2.3-0.3 c-35.3-3.9-67.1,21.6-71,56.9l-10.8,97.9C2266.6,489.6,2292.1,521.4,2327.4,525.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2383.2,307c0,0-30.4,22.6-58.3-8.7c0,0-37.6,6.5-60.9,55.9c-42.4,90.2-41.9,161.6-41.9,161.6 s25.4,13.6,88.3,7.6c50.7-4.9,96.6,4.2,96.6,4.2s7.3-53.4,8.5-111C2416.6,363.8,2401.6,334.3,2383.2,307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2335,292.1c0,0,16.8,14.2,26.6,15.3c8.8,1,11.3-7.6,11.3-7.6l10.3,7.2l-10.8,22.7l-10.1-15.1l-9.6,14.3 l-27.7-30.6L2335,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2310.3,231c-0.9,5.9,3.1,11.4,9,12.3c5.9,0.9,11.4-3.1,12.3-9c0.9-5.9-3.1-11.4-9-12.3 C2316.7,221.1,2311.2,225.2,2310.3,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2319.5,239.5c0,0,0.1,0,0.1,0c0.3,0.1,0.7-0.1,0.8-0.5c1-4-1.5-5.4-3.1-6.4c-0.7-0.4-1.4-0.8-1.5-1.3 c-0.1-0.2,0-0.6,0.3-1c2-3.3,6.4-2.5,6.6-2.4c0.3,0.1,0.7-0.1,0.7-0.5c0.1-0.3-0.1-0.7-0.5-0.7c-0.2,0-5.5-1.1-7.9,3 c-0.4,0.7-0.6,1.4-0.4,2c0.3,1,1.2,1.5,2.1,2c1.6,0.9,3.3,1.9,2.5,5C2319,239.1,2319.2,239.4,2319.5,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2397.6,246.1c-0.9,5.9,3.1,11.4,9,12.3s11.4-3.1,12.3-9c0.9-5.9-3.1-11.4-9-12.3 C2404,236.2,2398.5,240.2,2397.6,246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2408.1,254.8c0.1,0,0.1,0,0.2,0.1c0.3,0,0.6-0.2,0.7-0.6c0.2-3.2,2.1-3.5,4-3.9c1.1-0.2,2.1-0.4,2.7-1.2 c0.3-0.5,0.4-1.2,0.2-2c-1-4.7-6.3-5.4-6.5-5.4c-0.3,0-0.7,0.2-0.7,0.5c0,0.3,0.2,0.7,0.5,0.7c0.2,0,4.6,0.6,5.4,4.4 c0.1,0.5,0.1,0.8-0.1,1c-0.3,0.4-1,0.5-1.9,0.7c-1.9,0.4-4.7,0.9-5,5C2407.7,254.4,2407.9,254.7,2408.1,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2356.9,286.3L2356.9,286.3c22.1,3.5,42.8-11.6,46.2-33.7l3.2-20.7c3.5-22.1-11.6-42.8-33.7-46.2l0,0 c-22.1-3.5-42.8,11.6-46.2,33.7l-3.2,20.7C2319.8,262.1,2334.9,282.8,2356.9,286.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2349,254.8c-0.3,2.4,0.9,5.9,4.2,8.8c4.5,4,14.4,5.7,19.2,3.8c2.6-1,4.5-3,5.3-5c0.7-1.7,0.6-3.3-0.7-4.1 c-2.7-1.8-11-0.8-16.1-3.4c-5.5-2.7-9.5-4.2-11.2-2.2C2349.4,253.2,2349.1,253.9,2349,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2349,254.8c11.1,7,27,7.6,28.8,7.6c0.7-1.7,0.6-3.3-0.7-4.1c-2.7-1.8-11-0.8-16.1-3.4 c-5.5-2.7-9.5-4.2-11.2-2.2C2349.4,253.2,2349.1,253.9,2349,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2352.8,264.1c-3.7-3.3-4.7-7-4.4-9.4c0.1-1,0.5-1.8,1-2.4c2-2.2,6.1-0.8,12,2.1c2.6,1.3,6.2,1.7,9.4,2 c2.9,0.3,5.4,0.5,6.8,1.4c1.4,0.9,1.8,2.8,0.9,4.9c-1,2.3-3.1,4.3-5.7,5.3c-4.1,1.6-11,0.8-16.1-1.6 C2355.1,265.7,2353.8,265,2352.8,264.1z M2370.5,257.6c-3.3-0.3-7-0.7-9.8-2.1c-4.5-2.3-8.9-4.1-10.5-2.4c-0.4,0.4-0.6,1-0.7,1.7 l0,0c-0.2,2,0.7,5.3,4,8.3c4.2,3.7,13.8,5.6,18.6,3.7c2.7-1,4.3-3.1,5-4.6c0.2-0.6,0.9-2.4-0.5-3.3c-0.1-0.1-0.3-0.2-0.4-0.2 C2375.1,258,2372.9,257.8,2370.5,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2342.1,237.8c-0.7,2.1,0.6,4.3,2.9,5c2.3,0.7,4.6-0.3,5.3-2.4c0.7-2.1-0.6-4.3-2.9-5 C2345.1,234.6,2342.8,235.7,2342.1,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2385.1,248.2c-0.7,2.1,0.6,4.3,2.9,5c2.3,0.7,4.6-0.3,5.3-2.4c0.7-2.1-0.6-4.3-2.9-5 C2388.2,245.1,2385.8,246.1,2385.1,248.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2346.8,179c0,0-3.1-14.1,4.7-18.9c8-4.9,17.5,3.4,21.2,10c0,0,2.7-5.9,7.5-10.9c8.3-8.8,26.7-0.4,12.4,17.8 c0,0,7-8.7,20.5-3.6s4.8,20.2-7.6,21.7c0,0,15.1-1.4,18.2,11.4c1.4,6.1-1.8,9.9-7.4,11.4c-1,4.9-3.6,14.1-10.8,19.6 c0,0,0.1-12.4-4.3-20.3c-2.9-0.8-5.8-1.9-8.7-3.3c-16.3-8.2-24-18.6-24-18.6s-4.2,8.5-13.7,10.5c-4.7,1-9.6,0.7-14.1-0.7l0.2,0.2 c0,0-8.6,6-15.1,18.3c0,0-9.5-16.2,3.3-26.1C2322.8,189.7,2329.5,172.1,2346.8,179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2367,248.9c0.1,0,0.2,0.1,0.3,0.1c0.6,0,5.8-0.4,6-3.1c0.2-2.3-1.5-12.9-1.6-13.4c-0.1-0.3-0.4-0.6-0.7-0.5 c-0.3,0.1-0.6,0.4-0.5,0.7c0.5,3,1.7,11.3,1.5,13c-0.1,1.3-3.3,1.8-4.8,1.9c-0.3,0-0.6,0.3-0.6,0.7 C2366.6,248.6,2366.8,248.8,2367,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2385,234.8c-0.6,2.9-2.4,5.1-3.9,4.7c-1.5-0.3-2.2-3-1.5-5.9c0.6-2.9,2.4-5.1,3.9-4.7 C2385,229.2,2385.7,231.9,2385,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2362.7,230.7c-0.6,2.9-2.4,5.1-3.9,4.7c-1.5-0.3-2.2-3-1.5-5.9c0.6-2.9,2.4-5.1,3.9-4.7 C2362.7,225.1,2363.4,227.7,2362.7,230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2379.7,220.8c0.1,0.1,0.3,0.1,0.5,0.1c6.7-0.2,12.2,4.8,12.2,4.8c0.4,0.4,1.1,0.4,1.5-0.1 c0.4-0.4,0.4-1.1-0.1-1.5c-0.2-0.2-6.2-5.6-13.7-5.4c-0.6,0-1,0.5-1,1.1C2379.1,220.3,2379.3,220.7,2379.7,220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2350.8,217.8c0.2,0.1,0.5,0.1,0.8,0c8.3-3.1,12.4,0.4,12.5,0.5c0.4,0.4,1.1,0.3,1.5-0.1 c0.4-0.4,0.3-1.1-0.1-1.5c-0.2-0.2-5.2-4.4-14.6-0.9c-0.5,0.2-0.8,0.8-0.6,1.4C2350.3,217.5,2350.5,217.7,2350.8,217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2335.5,462.2c0,0,1.9,31.6-23.6,47.2C2312,509.4,2304.1,472.4,2335.5,462.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2330.7,231.6c-0.7-6.1-4.2-12.3-4.2-12.3s-12.3,39.8,7.8,59.1c15,14.3,47.9,17.4,62.9-6.2 c10.3-16.3,8.3-38.3,8.3-38.3s-2.7,6-4.6,10.4c-2,4.4-3.1,10.6-7.5,16.3l-4.1-4.2c-3.1-2.5-6.9-4.1-10.9-4.4c0,0-0.1,0-0.1,0 c-4.8-0.2-13-1.3-21.1-5.6c-1.5-0.8-3.1-1.3-4.8-1.7c-2.9-0.6-5.9-0.3-8.7,0.4l-7.3,2.8C2336.4,248.1,2332.2,245.8,2330.7,231.6z  M2349.4,248.4c1.4-0.4,2.8-0.2,4.1,0.4c11.2,5.4,20.1,6.6,24.5,6.8c2.8,0.1,5.3,2.2,5.5,5c0.1,0.8-0.1,1.7-0.5,2.5 c-2.3,5-7.8,9.8-21.6,6.9c-13-2.7-17.8-13.9-16.5-17.8C2345.6,250,2347.7,248.9,2349.4,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2204.4,457.9l131.2,50.3c8.6,3.3,18.3-1,21.6-9.6c3.3-8.6-1-18.3-9.6-21.6l-110.3-42.3l70.8-92 c5.6-7.3,4.3-17.8-3-23.4c-7.3-5.6-17.8-4.3-23.4,3l-84.4,109.7c-3.2,4.2-4.3,9.6-2.8,14.7C2195.7,452,2199.5,456.1,2204.4,457.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2325.3,504.3c0,0,11.8,6.5,27.2,7.2c14.4,0.7,19.4-2.9,23.9-7.3c4.5-4.4-15.5-21.1-24.9-22.9 C2342.1,479.5,2330.3,490.9,2325.3,504.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2351.5,511.4c7.5,0.7,14.6,2.8,20.9,7c2.8,1.9,7.6,8,11.4,4c4.7-5.9-21.8-22.6-27-24.7 C2343.6,490.1,2338.5,511.4,2351.5,511.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2358.2,507c7.3,0.3,14.5,2.7,21,6.1c3.7,1.2,8.2,7.6,11.7,3.1c3.1-4.9-10.8-12.7-14.3-15.3 c-5.3-3.1-11-5.8-17.1-7C2351,493.1,2349.7,506.1,2358.2,507z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2359.7,500.9c11.3-0.3,22.8,3.3,31.8,10.1c3.3,2.5,7.5-2.4,4.6-5.2c-3.4-3.7-7.4-6.9-11.7-9.5 c-7.5-4.4-15.9-7.6-24.6-8.6C2350.2,487,2350.3,501.7,2359.7,500.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2348.7,489.4c11.8-0.4,24.1,1.5,34.8,6.6c3.5,1.7,6.8,3.9,9.8,6.5c1.4,1.3,3.7,1.2,5-0.3 c4.8-6.6-17.8-18-22.9-19.8c-8.8-3.4-19.5-5.4-28.9-6C2337.2,476,2339.4,490.4,2348.7,489.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2378.4,513.1c0.1,0,0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.6c-0.1,0-5.4-4.9-14-8.4c-0.2-0.1-0.5,0-0.6,0.3 c-0.1,0.2,0,0.5,0.3,0.6c8.4,3.4,13.7,8.2,13.7,8.3C2378.2,513,2378.3,513,2378.4,513.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2384.9,507.3c0.2,0,0.3,0,0.4-0.2c0.2-0.2,0.1-0.5-0.1-0.6c-0.1,0-6.3-5.1-15.6-9.3c-0.2-0.1-0.5,0-0.6,0.2 c-0.1,0.2,0,0.5,0.2,0.6c9.2,4.2,15.3,9.1,15.4,9.2C2384.8,507.3,2384.9,507.3,2384.9,507.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2387.9,499.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.2,0.1-0.5-0.1-0.6c-0.1,0-7.6-4.8-14.6-7.8 c-0.2-0.1-0.5,0-0.6,0.2c-0.1,0.2,0,0.5,0.2,0.6c7,2.9,14.4,7.7,14.4,7.7C2387.8,499.1,2387.8,499.1,2387.9,499.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2324.9,298.3c0,0-35.9-10.9-75.2,28.3c-39.3,39.2-79.4,90.7-71.4,123.1c8.3,33.9,133.7,59.6,133.7,59.6 s-2.6-24.9,23.6-47.2l-72-32.5C2263.5,429.7,2350.2,330.6,2324.9,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2475.1,627.9c0.1,0,0.2,0,0.3,0c0.3-0.1,0.5-0.5,0.4-0.9c-14.3-35-76.9-75.9-77.5-76.3 c-0.3-0.2-0.7-0.1-0.9,0.2c-0.2,0.3-0.1,0.7,0.2,0.9c0.6,0.4,62.9,41.1,77,75.7C2474.7,627.7,2474.9,627.9,2475.1,627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2554.1,756.2c0,0,0.1,0,0.1,0c35.7-2.3,71.2-24.4,71.6-24.6c0.3-0.2,0.4-0.6,0.2-0.9 c-0.2-0.3-0.6-0.4-0.9-0.2c-0.4,0.2-35.6,22.2-70.9,24.4c-0.4,0-0.7,0.3-0.6,0.7C2553.5,755.9,2553.7,756.2,2554.1,756.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2549.3,745.5c0,0,0.1,0,0.1,0c37-4,72.8-25.6,73.2-25.8c0.3-0.2,0.4-0.6,0.2-0.9c-0.2-0.3-0.6-0.4-0.9-0.2 c-0.4,0.2-35.9,21.7-72.6,25.7c-0.4,0-0.6,0.4-0.6,0.7C2548.7,745.2,2548.9,745.5,2549.3,745.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2424.2,822.9c30.1,2.9,51.2-1.4,51.5-1.5c0.4-0.1,0.6-0.4,0.5-0.8c-0.1-0.4-0.4-0.6-0.8-0.5 c-0.3,0.1-32.4,6.6-73.8-2c-0.4-0.1-0.7,0.2-0.8,0.5c-0.1,0.4,0.2,0.7,0.5,0.8C2409.4,821.2,2417.1,822.2,2424.2,822.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2425.2,811.8c27.9,2.7,51.4-2.6,51.7-2.7c0.4-0.1,0.6-0.5,0.5-0.8c-0.1-0.4-0.4-0.6-0.8-0.5 c-0.4,0.1-38.5,8.7-75.1-1.7c-0.4-0.1-0.7,0.1-0.8,0.5c-0.1,0.4,0.1,0.7,0.5,0.8C2409.2,809.7,2417.4,811,2425.2,811.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2335.5,462.9c0.3,0,0.6-0.1,0.7-0.4c0.2-0.3,0-0.7-0.3-0.9l-71.3-32.2c4.6-6.3,39.4-53.9,52.9-75.5 c0.2-0.3,0.1-0.7-0.2-0.9c-0.3-0.2-0.7-0.1-0.9,0.2c-14.4,23.1-53,75.6-53.3,76.1c-0.1,0.2-0.2,0.4-0.1,0.6 c0.1,0.2,0.2,0.4,0.4,0.4l72,32.5C2335.3,462.9,2335.4,462.9,2335.5,462.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2412.1,480.6c0.4,0,0.7-0.2,0.7-0.6c8.1-68.9-10.5-118.1-10.6-118.6c-0.1-0.4-0.5-0.5-0.9-0.4 c-0.4,0.1-0.5,0.5-0.4,0.9c0.2,0.5,18.6,49.4,10.6,118C2411.4,480.2,2411.7,480.5,2412.1,480.6 C2412.1,480.6,2412.1,480.6,2412.1,480.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2391.7,535.8l163.9,18.1l33.3-94c2.9-8.1-2.6-16.9-11.2-17.8L2441.3,427c-6.2-0.7-12,3-14.1,8.8l-33.6,94.8 L2391.7,535.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2404.1,537.1l151.5,16.8l33.3-94c2.9-8.1-2.6-16.9-11.2-17.8l-124.2-13.7c-6.2-0.7-12,3-14.1,8.8 L2404.1,537.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2348.6,
    y: 480.1,
    transform: "matrix(0.1099 -0.9939 0.9939 0.1099 1572.2333 2808.0903)",
    className: "st13",
    width: 10.7,
    height: 92.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2311.9,510.1c0.3,0,0.7-0.2,0.7-0.6c0.1-0.4-0.2-0.7-0.5-0.8c-0.5-0.1-45.7-8.8-87.3-26 c-0.3-0.1-0.7,0-0.9,0.4c-0.1,0.3,0,0.7,0.4,0.9C2266,501.2,2311.4,510,2311.9,510.1C2311.9,510.1,2311.9,510.1,2311.9,510.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1069.7,1056.7c0,0,26.2,0.2,42.5,20.7C1112.2,1077.4,1086.3,1083.9,1069.7,1056.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M861.1,1021.2c0,0-16.1,11.1-27.1,39.2c-7.9,20.3-28.4,54-36.9,73.6c-34.3,79.1-4.3,120.5,101.1,117.3 c49.8-1.5,61.1-40,52.9-73.8c-8.1-33.6-18-66-9.8-103c0,0-8.1-32.9-27.5-39C894.4,1029.4,861.1,1021.2,861.1,1021.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.1,
    y: 1095.9,
    transform: "matrix(0.9993 -3.672023e-02 3.672023e-02 0.9993 -40.7293 33.44)",
    className: "st12",
    width: 37.8,
    height: 59.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M881.9,1128.4c0,0,12,9,27.4,5.9l-0.8-20.6L881.9,1128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M898.2,1131L898.2,1131c21.9-1.1,38.8-19.8,37.7-41.7l-1-20.6c-1.1-21.9-19.8-38.8-41.7-37.7l0,0 c-21.9,1.1-38.8,19.8-37.7,41.7l1,20.6C857.6,1115.2,876.2,1132.1,898.2,1131z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M892.3,1370.2c34.9-1.3,86.4-12.7,71.1-60.1c-7.9-24.4-17.8-57.3-12.4-101.6c4.3-34.7-23.8-69.4-59.4-69.2 l-2.3,0.1c-34,1.8-49.5,36.4-44.7,71c6.3,44.6-3,76.1-11.5,98.9C810,1371.7,892.3,1370.2,892.3,1370.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M902.3,1174.2c-1.7-12.8,7.3-24.5,20.1-26.2L1027,1134l57.5-88.6c4-6.2,12.1-8.7,19-5.5 c7.5,3.5,10.8,12.4,7.3,20l-49.6,107.1c-2.9,6.1-8.7,10.7-15.8,11.7l-116.7,15.5C915.7,1196,904,1187,902.3,1174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M889.5,1077.8c0.1,3-1,5.4-2.5,5.5c-1.5,0.1-2.9-2.3-3-5.2c-0.1-3,1-5.4,2.5-5.5 C888,1072.5,889.4,1074.8,889.5,1077.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M909.5,1142c0,0,41.6-8.9,112.7-11.8c0,0,29.2-48.4,47.5-73.5c0,0,16.1,19.3,42.5,20.7 c0,0-31.2,94-57.4,104.8s-101.6,21.5-101.6,21.5L909.5,1142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M913.5,1076.6c0.1,3-1,5.4-2.5,5.5s-2.9-2.3-3-5.2c-0.1-3,1-5.4,2.5-5.5 C912,1071.3,913.4,1073.6,913.5,1076.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M872.9,1089.2c-0.2,2.1,1.5,4,3.8,4.3c2.3,0.3,4.4-1.3,4.6-3.4c0.2-2.1-1.5-4-3.8-4.3 C875.2,1085.6,873.2,1087.1,872.9,1089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M917.7,1088.7c-0.2,2.1,1.5,4,3.8,4.3c2.3,0.3,4.4-1.3,4.6-3.4c0.2-2.1-1.5-4-3.8-4.3 C920,1085.1,917.9,1086.6,917.7,1088.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M909.5,1142c0,0,19,3.5,38.5,30.9c5.3,7.5,17.6,27.6,18.1,39.7c0.5,13.1-12.6,21-11.7,44.6 c0.9,23.5,18.6,37.9,9,52.9c-5.6,8.8-93.1,23.8-130.9,1.4c-21-12.5,13.4-40.7,3-105c-7.9-49,19-57.8,36.2-63.1 c0,0,14.7,36.9,27.7,35.8C912.8,1178,909.5,1142,909.5,1142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M843.4,1085.6c0.3,5.8,5.3,10.3,11.1,10c5.8-0.3,10.3-5.3,10-11.1c-0.3-5.8-5.3-10.3-11.1-10 C847.6,1074.8,843.1,1079.7,843.4,1085.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M908.5,1022.6c0,0,18.3-6.2,31,10.9c11.1,15,6.6,31.4-0.2,46.7C939.2,1080.2,913.8,1046.8,908.5,1022.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M925,1083.2c0.3,5.8,5.3,10.3,11.1,10c5.8-0.3,10.3-5.3,10-11.1c-0.3-5.8-5.3-10.3-11.1-10 C929.2,1072.4,924.7,1077.4,925,1083.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M894.3,1103.5c0,2.9,2.7,5.2,6.1,5.2c3.3,0,6-2.4,6-5.3c0-0.7-0.2-1.3-0.4-1.9c-0.9-2-3.1-3.3-5.7-3.3 c-2.3,0-4.2,1.1-5.2,2.7C894.5,1101.7,894.3,1102.6,894.3,1103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M895,1101c7.1,3.1,10.9,0.6,10.9,0.6l0,0c-0.9-2-3.1-3.3-5.7-3.3C898,1098.3,896,1099.4,895,1101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M936.1,1088.8c0.3-0.1,0.5-0.3,0.5-0.6c-0.2-3.1,1.6-3.7,3.3-4.3c1-0.4,2-0.7,2.4-1.6c0.3-0.5,0.2-1.2,0-2 c-1.6-4.4-6.8-4.4-7.1-4.4c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6c0.2,0,4.6,0,5.9,3.6c0.2,0.5,0.2,0.8,0.1,1 c-0.2,0.4-0.9,0.7-1.7,0.9c-1.8,0.6-4.4,1.5-4.2,5.6C935.4,1088.6,935.7,1088.9,936.1,1088.8 C936,1088.8,936.1,1088.8,936.1,1088.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M854.3,1091.1c0.3-0.1,0.5-0.3,0.5-0.5c0.4-4-2.3-5-4-5.7c-0.8-0.3-1.5-0.6-1.7-1c-0.1-0.2-0.1-0.6,0.1-1 c1.4-3.5,5.9-3.4,6-3.4c0.3,0,0.6-0.2,0.6-0.6c0-0.3-0.2-0.6-0.6-0.6c-0.2,0-5.5-0.2-7.2,4.1c-0.3,0.8-0.3,1.4-0.1,2 c0.4,0.9,1.4,1.3,2.4,1.7c1.7,0.7,3.5,1.3,3.2,4.4c0,0.3,0.2,0.6,0.6,0.7C854.2,1091.1,854.3,1091.1,854.3,1091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M922.7,1034.3c0,0-8.2,21.7-29.9,22.2c-25.5,0.6-36,33.1-36,33.1s-14.7-24.4-10.5-42 C856,1007.5,897.4,997.6,922.7,1034.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M916.6,1065.8c0.1,0,0.3-0.1,0.4-0.2c0.5-0.3,0.6-1,0.3-1.4c-0.1-0.1-2.5-3.6-6.3-4.1 c-2.2-0.3-4.5,0.5-6.6,2.3c-0.4,0.4-0.5,1-0.1,1.5c0.4,0.4,1,0.5,1.5,0.1c1.7-1.4,3.3-2.1,4.9-1.9c2.9,0.4,4.8,3.2,4.8,3.2 C915.7,1065.7,916.2,1065.8,916.6,1065.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M892.7,1065c0.2,0,0.4-0.1,0.5-0.3c0.4-0.4,0.4-1,0.1-1.5c-0.1-0.1-2.4-2.6-5.8-2.5 c-2.4,0.1-4.7,1.4-6.8,3.9c-0.4,0.4-0.3,1.1,0.1,1.5c0.4,0.4,1.1,0.3,1.5-0.1c1.7-2,3.4-3.1,5.2-3.2c2.4-0.1,4.2,1.8,4.2,1.8 C891.9,1065,892.3,1065.1,892.7,1065z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M900.3,1094.2C900.4,1094.2,900.4,1094.2,900.3,1094.2c0.6-0.2,5.4-2.1,4.8-4.7c-0.5-2.2-5.2-11.7-5.4-12.1 c-0.2-0.3-0.5-0.4-0.8-0.3c-0.3,0.2-0.4,0.5-0.3,0.8c1.3,2.7,4.9,10.1,5.3,11.8c0.3,1.2-2.6,2.7-4,3.2c-0.3,0.1-0.5,0.5-0.4,0.8 C899.7,1094.1,900,1094.3,900.3,1094.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M944.1,1240.8c9.5-1.9,15.2-7,15.5-7.3c0.3-0.2,0.3-0.6,0-0.9c-0.2-0.3-0.6-0.3-0.9,0 c-0.1,0.1-9.3,8.4-24,7.6c-0.3,0-0.6,0.2-0.7,0.6c0,0.3,0.2,0.6,0.6,0.7C938.1,1241.6,941.3,1241.3,944.1,1240.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M892.7,1243.3c1-0.2,1.6-0.4,1.6-0.4c0.3-0.1,0.5-0.4,0.4-0.8c-0.1-0.3-0.4-0.5-0.8-0.4 c-0.2,0-15.9,4.3-37.5-2c-0.3-0.1-0.7,0.1-0.8,0.4c-0.1,0.3,0.1,0.7,0.4,0.8C874,1246.2,888,1244.2,892.7,1243.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1084.2,1050.2c0,0,8.8-14.4,22-19s19.4-3.3,24.4-0.1c5,3.2-11,22.8-19.6,26.4 C1102.5,1061.1,1091.2,1061.7,1084.2,1050.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1083.4,1047.1l0.4-0.8c0.1-0.3,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.4,0.3-0.5c0.2-0.4,0.4-0.7,0.6-1 c0.4-0.7,0.8-1.4,1.3-2c0.4-0.7,0.9-1.3,1.3-2l1.4-1.9c1.8-2.5,3.8-4.9,5.9-7.2c2.1-2.3,4.4-4.4,6.8-6.4l1.8-1.5l1.9-1.4l1-0.7 l1-0.6l2-1.2c1.5-0.9,3.5-0.7,4.7,0.7c1.3,1.5,1.2,3.8-0.4,5.1l-0.2,0.2l-1.5,1.3l-0.8,0.7l-0.7,0.7l-1.4,1.4l-0.9,1 c0.5-0.3,1.1-0.5,1.6-0.8c1.2-0.6,2.3-1.3,3.5-1.9c2.3-1.3,4.5-2.8,6.7-4.4c1.1-0.8,2.1-1.6,3.2-2.4l1.6-1.3l0.8-0.6l0.7-0.7 c2-1.7,3.9-3.7,5.7-5.6l0.1-0.1c1.1-1.2,2.9-1.4,4.3-0.5c1.5,1,2,3.1,1,4.6c-1.6,2.5-3.3,5-5.2,7.2l-0.7,0.9l-0.7,0.8l-0.5,0.6 c0.2-0.1,0.3-0.2,0.5-0.3l1.6-1.2l0.8-0.6l0.8-0.6c2.2-1.7,4.1-3.5,6.1-5.4l0.1-0.1c1.1-1.1,2.9-1.3,4.3-0.3 c1.5,1.1,1.8,3.2,0.7,4.7c-1.8,2.4-3.6,4.8-5.6,7l-0.7,0.8l0.6-0.4l1.7-1.2l0.8-0.6l0.8-0.6l1.6-1.3l0.2-0.2c1.2-1,3.1-1,4.3,0.1 c1.4,1.2,1.5,3.3,0.3,4.7l-1.6,1.8l-0.8,0.9l-0.8,0.8l-1.7,1.7l-1.8,1.6c-0.9,0.8-1.9,1.6-2.9,2.4l1.5-0.9l1-0.7l1-0.7l1.9-1.5 l0.2-0.2c1.3-1,3.2-0.9,4.4,0.3c1.3,1.3,1.3,3.4,0.1,4.7l-2,2l-1,1l-1.1,0.9l-2.1,1.9l-2.3,1.7c-0.4,0.3-0.8,0.6-1.1,0.8l-1.2,0.8 c-0.8,0.5-1.6,1.1-2.4,1.5l-2.5,1.4c-0.8,0.5-1.7,0.9-2.5,1.3c-3.4,1.7-6.9,3.1-10.5,4.2l-2.7,0.8c-0.9,0.2-1.8,0.5-2.8,0.7 c-0.9,0.2-1.9,0.4-2.8,0.6c-0.5,0.1-1,0.2-1.4,0.3c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.5,0.1-0.9,0.1l-0.8,0.1c-0.4,0-0.9,0-1.4,0 c-3.5-0.4-6-3.6-5.6-7c0.4-3.5,3.6-6,7-5.6c0.1,0,0.2,0,0.4,0c-0.3-0.6-0.4-1.3-0.5-2c0-0.7,0-1.4,0.2-2.1 c-0.1-0.2-0.2-0.4-0.2-0.7c-3,0.3-5.8-1.5-6.8-4.5c-0.1-0.3-0.1-0.5-0.2-0.8c-1.2,1.9-2.4,3.8-3.4,5.8l-0.9,1.8 c-0.3,0.6-0.6,1.2-0.8,1.8c-0.3,0.6-0.5,1.2-0.8,1.8c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.3-0.1,0.4 c-0.1,0.5-0.3,1-0.5,1.5c-1.6,3.2-5.4,4.4-8.6,2.9C1083.1,1054.1,1081.8,1050.2,1083.4,1047.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1125.3,1049.7c0,0,0.1,0,0.1,0c7.8-3.3,14.3-9.1,14.3-9.1c0.3-0.2,0.3-0.6,0-0.9c-0.2-0.3-0.6-0.3-0.9,0 c-0.1,0.1-6.4,5.7-14,8.9c-0.3,0.1-0.5,0.5-0.3,0.8C1124.7,1049.6,1125,1049.7,1125.3,1049.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1124.2,1041.7c0.1,0,0.1,0,0.2-0.1c8.5-5.5,14.3-11.3,14.3-11.4c0.2-0.2,0.2-0.6,0-0.9 c-0.2-0.2-0.6-0.2-0.9,0c-0.1,0.1-5.7,5.8-14.1,11.2c-0.3,0.2-0.4,0.6-0.2,0.9C1123.7,1041.6,1124,1041.7,1124.2,1041.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1118.3,1036.6c0.1,0,0.2,0,0.2-0.1c5.3-3.5,11-9.7,11.2-9.9c0.2-0.3,0.2-0.6,0-0.9c-0.3-0.2-0.6-0.2-0.9,0 c-0.1,0.1-5.9,6.3-11,9.7c-0.3,0.2-0.4,0.6-0.2,0.9C1117.8,1036.5,1118.1,1036.6,1118.3,1036.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1111.6,1048.1c0.2,0,0.4-0.2,0.4-0.3c0.1-0.3,0-0.7-0.3-0.8c-2.6-1.2-6.1-1.4-7.9-1.5 c2.6-3.9,3.5-9,3.5-9.2c0.1-0.3-0.2-0.7-0.5-0.7c-0.3-0.1-0.7,0.2-0.7,0.5c0,0.1-1,6-4,9.7c-0.2,0.2-0.2,0.5-0.1,0.7 c0.1,0.2,0.3,0.4,0.6,0.3c0.1,0,5.2-0.3,8.6,1.3C1111.4,1048.1,1111.5,1048.1,1111.6,1048.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M963.8,1202.7c0,0,0.1,0,0.1,0c0.3-0.1,0.4-0.5,0.3-0.8c-0.1-0.1-6.5-13.5-17.9-26c-0.2-0.3-0.6-0.3-0.9,0 c-0.3,0.2-0.3,0.6,0,0.9c11.2,12.3,17.6,25.6,17.7,25.7C963.3,1202.6,963.6,1202.7,963.8,1202.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1108.4,1089.1c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.2-0.6-0.6-0.7c-0.3,0-29.6-1.9-44.8-22.1 c-0.2-0.3-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.9c15.6,20.7,45.4,22.6,45.7,22.6C1108.3,1089.2,1108.4,1089.1,1108.4,1089.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M909,1369.3L872,1548l-0.8,4.1c-0.2,0.8-0.4,1.6-0.7,2.3L805.4,1720c-4.7,12-18.2,17.9-30.2,13.2 c-12-4.7-17.9-18.2-13.2-30.2l65.1-165.8l-3.9-176.1c-0.3-23.9,18.6-34.8,42.5-35.1c23.9-0.3,43.9,10,44.2,33.9 C909.9,1363.1,909.6,1366.3,909,1369.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M963,1364.8l7.1,182.3l0.2,4.1c0,0.8,0,1.6-0.1,2.3l-23.4,176.6c-1.7,12.8-13.4,21.7-26.2,20 c-12.8-1.7-21.7-13.4-20-26.2l23.3-176.6l-46.1-170c-6.1-23.2,7.8-46.9,31-52.9s46.9,7.8,52.9,31 C962.4,1358.5,962.9,1361.8,963,1364.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M989.2,1786.5l-56.2-0.7l-11.8-25.2l-5.1,25l-16.2-0.2c-14.8-31,1.1-69.8,1.1-69.8s23.5,4.8,51.7,0.9 l-0.7,25.2l41.9,30.5C1000.2,1776.8,997,1786.6,989.2,1786.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M908.1,1751.3c-0.6,0-1.2-0.1-1.8-0.4c-1.2-0.5-2.1-1.4-2.6-2.6c-0.5-1.2-0.5-2.5,0-3.7 c0.5-1.2,1.4-2.1,2.6-2.6c1.2-0.5,2.5-0.5,3.7,0c1.2,0.5,2.1,1.4,2.6,2.6l0,0c1,2.4-0.2,5.2-2.6,6.2 C909.3,1751.2,908.7,1751.3,908.1,1751.3z M908.1,1743c-0.5,0-0.9,0.1-1.4,0.3c-0.9,0.4-1.6,1-1.9,1.9c-0.4,0.9-0.4,1.8,0,2.7 c0.4,0.9,1,1.6,1.9,1.9c0.9,0.4,1.8,0.4,2.7,0c1.8-0.7,2.7-2.8,1.9-4.6c-0.4-0.9-1-1.6-1.9-1.9C909,1743.1,908.6,1743,908.1,1743z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M999.1,1517.8c-13.2-126.8-49.2-201.5-49.2-201.5s-12.1,2.1-29.3,3.6c-4.3,0.4-49.7,3.8-84.9-8.1 c0,0-34.3,29.5-34.8,97.3c-0.3,45.1,3.1,126,3.1,126L748.5,1672c108.1,51.1,229.9,28.9,229.9,28.9S1005,1574.5,999.1,1517.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,1785l-54.4-14.2l-5.4-27.3l-11,23.1l-15.7-4.1c-6.9-33.7,17.8-67.5,17.8-67.5s21.6,10.3,50,13.3 l-6.7,24.3l33.3,39.7C846.1,1778.1,840.5,1786.9,833.1,1785z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M762.7,1731.3c-0.6-0.2-1.2-0.4-1.7-0.8c-1-0.8-1.7-1.9-1.9-3.1c-0.2-1.3,0.1-2.5,0.9-3.6 c0.8-1,1.9-1.7,3.1-1.9c1.3-0.2,2.5,0.1,3.6,0.9c1,0.8,1.7,1.9,1.9,3.1l0,0c0.4,2.6-1.4,5-4,5.4 C764,1731.5,763.3,1731.4,762.7,1731.3z M764.8,1723.2c-0.5-0.1-0.9-0.1-1.4-0.1c-0.9,0.1-1.8,0.6-2.3,1.4 c-0.6,0.8-0.8,1.7-0.7,2.6c0.1,0.9,0.6,1.8,1.4,2.3c0.8,0.6,1.7,0.8,2.6,0.7c1.9-0.3,3.3-2.1,3-4c-0.1-0.9-0.6-1.8-1.4-2.3 C765.6,1723.5,765.2,1723.3,764.8,1723.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M897.8,1219.4l45.4,0.4l0,0c0-3.6-2.8-6.5-6.4-6.5l-32.5-0.3C900.7,1213,897.8,1215.8,897.8,1219.4 L897.8,1219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M881.2,1343.8l73.9,0.7c6.4,0.1,11.7-5.1,11.7-11.5l1-101.5c0.1-6.4-5.1-11.7-11.5-11.7l-73.9-0.7 c-6.4-0.1-11.7,5.1-11.7,11.5l-1,101.5C869.7,1338.4,874.8,1343.7,881.2,1343.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M779.8,1281.3l34.7-93.3c4.5-12.1,17.9-18.2,30-13.8c12.1,4.5,18.2,17.9,13.8,30l-24.4,65.6l90.7,15.9 c7.3,1.3,12.7,7.8,12.4,15.4c-0.3,8.3-7.3,14.8-15.6,14.5l-121.7-4.4c-2.3-0.1-4.7-0.5-6.9-1.4 C781.3,1305.6,775.5,1292.8,779.8,1281.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M905.3,1290.9c0,0,15.4-7.1,28.9-3.5c13.5,3.6,18,8.1,20.4,13.5c2.4,5.4-21.8,12.8-31,11 C914.4,1310.1,904.7,1304.4,905.3,1290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M914,1298.1c7-5.1,15.2-8.8,23.6-10.7c1.1-0.2,2.9-0.6,4-0.7c2.6,0,5.9-1.1,5.5-4.3c-0.7-4.7-7.2-3-10.5-3.2 c-10.5,0.8-20.8,3.8-30.1,8.8C898.3,1292.7,907,1304.4,914,1298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M933.2,1299.9c12-0.2,24-2.6,34.9-7.4c3.7-1.5,1.7-7.3-2.1-6.3c-3,0.7-6,1.3-9,1.6 c-7.5,0.8-15.2,0.8-22.7-0.5C924.6,1284.9,923.1,1300.4,933.2,1299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M935.9,1307.4c12.1,0.3,24.2-1.5,35.5-5.7c3.8-1.3,2.1-7.2-1.7-6.4c-3.4,0.6-6.8,1.1-10.2,1.2 c-7.3,0.4-14.8-0.1-21.9-1.6C928,1292.1,926,1307.4,935.9,1307.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M932.6,1311.1c12.3,2.9,25.3,3.2,37.5-0.3c4-1,2.6-7.3-1.4-6.5c-0.7,0.1-2.4,0.2-3.1,0.3 c-9.8,0.4-19.8-1.6-28.9-5.4C927.9,1294.4,922.7,1309.2,932.6,1311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M920.5,1314c10.3,4.8,21.9,7.4,33.3,7c3.6-0.1,7.7-0.7,11.2-1.6c4-0.7,3.1-6.9-0.9-6.6 c-0.1,0-2.6,0.2-2.8,0.2c-9.8,0.5-19.6-2.2-28.4-6.4c-2.1-1.1-4.2-2.2-6.1-3.5C919.2,1297.1,911.5,1310.1,920.5,1314z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M956.8,1313.9c0.3-0.1,0.5-0.4,0.5-0.7c0-0.3-0.4-0.6-0.7-0.5c-0.1,0-8.4,1.2-16.6-0.4 c-0.3-0.1-0.7,0.2-0.7,0.5c-0.1,0.3,0.2,0.7,0.5,0.7C948.2,1315.1,956.7,1313.9,956.8,1313.9 C956.8,1313.9,956.8,1313.9,956.8,1313.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M961.7,1304.7C961.7,1304.7,961.7,1304.7,961.7,1304.7c0.4-0.1,0.6-0.4,0.5-0.7c-0.1-0.3-0.4-0.5-0.7-0.5 c0,0,0,0,0,0c-0.5,0.1-8.3,1.6-18,1.5c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6C953.3,1306.4,961.2,1304.8,961.7,1304.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M954,1297.2c1.3-0.3,2.2-0.5,2.3-0.5c0.3-0.1,0.5-0.4,0.5-0.7c-0.1-0.3-0.4-0.5-0.7-0.5c-0.1,0-8.4,2-14.6,2 c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6C945.8,1298.7,951,1297.8,954,1297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M871.7,1143.4c0,0-47-0.9-70.7,49.5c-23.7,50.3-33.1,92.4-24.6,111.9c10.8,24.6,120.7,22.5,120.7,22.5 s12.5-18.6,5.9-50.5c0,0-35.9-7.8-60.2-9.7C842.8,1267.2,876.5,1181.4,871.7,1143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M870.4,1271.3c0.3-0.1,0.5-0.3,0.5-0.5c0-0.3-0.2-0.6-0.5-0.7c-8.7-1.2-23.1-3-26.7-3.4 c8.2-19.8,20-66.5,20.1-67c0.1-0.3-0.1-0.7-0.5-0.8c-0.3-0.1-0.7,0.1-0.8,0.5c-0.1,0.5-12.1,48.3-20.3,67.6 c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,17.5,2.2,27.5,3.5C870.3,1271.3,870.4,1271.3,870.4,1271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M884.5,1327.9c0.2,0,0.3-0.1,0.4-0.3c11.4-21.7,6.1-53.1,6-53.4c-0.1-0.3-0.4-0.6-0.7-0.5 c-0.3,0.1-0.6,0.4-0.5,0.7c0.1,0.3,5.3,31.3-5.9,52.6c-0.2,0.3,0,0.7,0.3,0.8C884.2,1328,884.4,1328,884.5,1327.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M901.6,1186.3c3.4-0.7,6.2-2.5,8.5-5.5c9.1-12.1,5.5-38.7,5.4-39.8c0-0.3-0.4-0.6-0.7-0.5 c-0.3,0-0.6,0.4-0.5,0.7c0,0.3,3.7,27.3-5.1,38.9c-2.2,2.9-5.1,4.7-8.5,5.2c-19.3,2.7-33.7-41.1-33.8-41.6 c-0.1-0.3-0.4-0.5-0.8-0.4c-0.3,0.1-0.5,0.5-0.4,0.8c0.6,1.8,14.8,45.3,35.1,42.4C901,1186.4,901.3,1186.3,901.6,1186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M900.3,1109.3c-1.8,0-3.4-0.6-4.7-1.6c-1.3-1.1-2-2.6-2-4.1c0,0,0,0,0,0c0-1,0.3-2,0.9-2.9 c1.2-1.8,3.4-3,5.8-3c2.8,0,5.2,1.4,6.2,3.7c0.3,0.7,0.5,1.4,0.5,2.1c0,2.8-2.2,5.2-5.2,5.7 C901.3,1109.3,900.8,1109.3,900.3,1109.3z M895.5,1101.3c-0.4,0.7-0.7,1.4-0.7,2.2c0,1.2,0.6,2.4,1.6,3.2c1,0.9,2.4,1.4,3.9,1.4 c3,0,5.4-2.1,5.4-4.6c0-0.6-0.1-1.1-0.4-1.6c-0.8-1.8-2.9-3-5.1-3c-0.4,0-0.8,0-1.2,0.1C897.6,1099.3,896.3,1100.1,895.5,1101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M919.2,1692.3c-38.5,0-72.4-5.7-97.5-11.6c-41-9.7-67.5-22.2-67.7-22.3c-0.4-0.2-0.5-0.6-0.4-1 c0.2-0.4,0.6-0.5,1-0.4c0.3,0.1,26.6,12.5,67.5,22.2c37.7,8.9,96,17.2,159.1,6.3c0.4-0.1,0.8,0.2,0.9,0.6c0.1,0.4-0.2,0.8-0.6,0.9 C959.9,1690.8,938.9,1692.3,919.2,1692.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2641.5,1696.9h-396.8c-11.9,0-21.6-9.7-21.6-21.6v-1.6c0-11.9,9.7-21.6,21.6-21.6h396.8 c11.9,0,21.6,9.7,21.6,21.6v1.6C2663.1,1687.3,2653.4,1696.9,2641.5,1696.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2255.9,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2286.7,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2317.5,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2348.2,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2379,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2409.7,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2440.5,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2471.2,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2502,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2532.7,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2563.5,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2594.3,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2625,
    y: 1652.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2626.3,1652.1h-396.8c-11.9,0-21.6-9.7-21.6-21.6v-1.6c0-11.9,9.7-21.6,21.6-21.6h396.8 c11.9,0,21.6,9.7,21.6,21.6v1.6C2647.9,1642.5,2638.2,1652.1,2626.3,1652.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2240.8,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2271.5,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2302.3,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2363.8,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2394.5,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2425.3,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2456.1,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2486.8,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.6,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.3,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2579.1,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2609.8,
    y: 1607.3,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2641.5,1786.5h-396.8c-11.9,0-21.6-9.7-21.6-21.6v-1.6c0-11.9,9.7-21.6,21.6-21.6h396.8 c11.9,0,21.6,9.7,21.6,21.6v1.6C2663.1,1776.8,2653.4,1786.5,2641.5,1786.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2255.9,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2286.7,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2317.5,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2348.2,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2379,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2409.7,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2440.5,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2471.2,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2502,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2532.7,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2563.5,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2594.3,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2625,
    y: 1741.7,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2595.5,1741.7h-396.8c-11.9,0-21.6-9.7-21.6-21.6v-1.6c0-11.9,9.7-21.6,21.6-21.6h396.8 c11.9,0,21.6,9.7,21.6,21.6v1.6C2617.2,1732,2607.5,1741.7,2595.5,1741.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2210,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2240.8,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2271.5,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2302.3,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2363.8,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2394.5,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2425.3,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2456.1,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2486.8,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.6,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.3,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2579.1,
    y: 1696.9,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2580.6,1607.3h-396.8c-11.9,0-21.6-9.7-21.6-21.6v-1.6c0-11.9,9.7-21.6,21.6-21.6h396.8 c11.9,0,21.6,9.7,21.6,21.6v1.6C2602.3,1597.7,2592.6,1607.3,2580.6,1607.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2195.1,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2225.9,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2256.6,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2287.4,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2318.1,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2348.9,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2379.7,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2410.4,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2441.2,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2471.9,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2502.7,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2533.4,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2564.2,
    y: 1562.6,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2600,1562.9h-396.8c-11.9,0-21.6-9.7-21.6-21.6v-1.6c0-11.9,9.7-21.6,21.6-21.6H2600 c11.9,0,21.6,9.7,21.6,21.6v1.6C2621.6,1553.3,2611.9,1562.9,2600,1562.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2214.4,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2245.2,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2275.9,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2306.7,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2337.5,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2368.2,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2399,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2429.7,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2460.5,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2491.2,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2522,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2552.7,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2583.5,
    y: 1518.1,
    className: "st27",
    width: 5.1,
    height: 44.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1347.1,1786.6h-235.3c-27.2,0-49.3-22.1-49.3-49.3v-258c0-27.2,22.1-49.3,49.3-49.3h235.3 c27.2,0,49.3,22.1,49.3,49.3v258C1396.4,1764.5,1374.3,1786.6,1347.1,1786.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1324.2,1536.2h-189.6c-23.5,0-42.6-19.1-42.6-42.6v0c0-23.5,19.1-42.6,42.6-42.6h189.6 c23.5,0,42.6,19.1,42.6,42.6v0C1366.8,1517.2,1347.7,1536.2,1324.2,1536.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1127.4,1615.6L1127.4,1615.6c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9h0 c14.9,0,26.9,12,26.9,26.9l0,0C1154.3,1603.5,1142.3,1615.6,1127.4,1615.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1198.2,1615.6L1198.2,1615.6c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9l0,0 c14.9,0,26.9,12,26.9,26.9l0,0C1225.1,1603.5,1213.1,1615.6,1198.2,1615.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1269.1,1615.6L1269.1,1615.6c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9h0 c14.9,0,26.9,12,26.9,26.9l0,0C1296,1603.5,1283.9,1615.6,1269.1,1615.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1127.4,1690.5L1127.4,1690.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9h0 c14.9,0,26.9,12,26.9,26.9l0,0C1154.3,1678.5,1142.3,1690.5,1127.4,1690.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1198.2,1690.5L1198.2,1690.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9l0,0 c14.9,0,26.9,12,26.9,26.9l0,0C1225.1,1678.5,1213.1,1690.5,1198.2,1690.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1339.9,1690.5L1339.9,1690.5c-14.9,0-26.9-12-26.9-26.9v-75c0-14.9,12-26.9,26.9-26.9l0,0 c14.9,0,26.9,12,26.9,26.9v75C1366.8,1678.5,1354.7,1690.5,1339.9,1690.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1269.1,1690.5L1269.1,1690.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9h0 c14.9,0,26.9,12,26.9,26.9l0,0C1296,1678.5,1283.9,1690.5,1269.1,1690.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1127.4,1765.5L1127.4,1765.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9h0 c14.9,0,26.9,12,26.9,26.9l0,0C1154.3,1753.4,1142.3,1765.5,1127.4,1765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1198.2,1765.5L1198.2,1765.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9l0,0 c14.9,0,26.9,12,26.9,26.9l0,0C1225.1,1753.4,1213.1,1765.5,1198.2,1765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1339.9,1765.5L1339.9,1765.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9l0,0 c14.9,0,26.9,12,26.9,26.9l0,0C1366.8,1753.4,1354.7,1765.5,1339.9,1765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1269.1,1765.5L1269.1,1765.5c-14.9,0-26.9-12-26.9-26.9l0,0c0-14.9,12-26.9,26.9-26.9h0 c14.9,0,26.9,12,26.9,26.9l0,0C1296,1753.4,1283.9,1765.5,1269.1,1765.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_x31_",
    className: "st20",
    d: "M3144.6,1880.2H255.4c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4h2889.2c1.9,0,3.4,1.5,3.4,3.4 S3146.5,1880.2,3144.6,1880.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSpecific);
export default __webpack_public_path__ + "static/media/job-specific.c592cbde.svg";
export { ForwardRef as ReactComponent };